<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-dukes-castle">
<h1>The Duke’s Castle</h1>
<p>“Welcome to our home, my Lord.”</p>
<p>“Thank you for the invite, sir.”</p>
<p>“It’s been a while, yes, we haven’t seen you and your sister Helewise since the plague. How is your sister by the way?”</p>
<p>“She is well but misses our parents dreadfully.”</p>
<p>“How many years now since the deadly plague?”</p>
<p>“It’s been five years. A hard and lonely five years of my life without them. That peddler came not only with his merchandise but also with the plague. It wiped out hundreds of our tenants also.”</p>
<p>“It was a rough year, no one worked the fields or out fishing. What the plague didn’t take, starvation did.”</p>
<p>“Dinner is ready to serve, my dear husband.”</p>
<p>Their first course was fish chowder, very creamy with mussels and clams. The main course was a baked duck with Krispy glazed skin in orange sauce. Green beans sautéed with garlic, onion and baby carrots.</p>
<p>The third course was a grilled trout stuffed with breadcrumbs, wild sage and onions. The trout was pink and flakey and full of juiciness. Dessert was a raisin pudding, cooked in brandy sauce.</p>
<p>“Is everything alright, Sir Armando?”</p>
<p>“Everything was magnificent, you have a wonderful cook, Duchess Bella.”</p>
<p>“Yes, I think we will keep her. Sir Armando, we heard you were looking for a wife.”</p>
<p>“News travel fast, I take it,”</p>
<p>“Well yes, a rich man like yourself, it doesn’t take long.”</p>
<p>“Yes, you are right, Duke.”</p>
<p>“So far, I haven’t had any luck in that field.”</p>
<p>“Would you mind if we introduced you to our daughter, Roseabella? She’ll be eighteen in a few months and will be ready to be wed. She is taught to manage a household. She’s not beautiful like her younger sisters but she carries herself well and has fine features.”</p>
<p>“She has a beautiful name, your Duchess. If she looks like her mother, I won’t be disappointed.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?369cf940